import { useRef } from "react";
import { Camera, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function SettingsProfileCard({ logoUrl, profilePhoto, boutiqueName, plan, vitrineUrl, user, isDark, accent, onImageUpload }) {
  const logoInputRef = useRef(null);
  const photoInputRef = useRef(null);

  const getInitials = (name) => (name || "").split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2) || "?";

  return (
    <div className="s-card s-profile-card" data-testid="profile-card">
      {/* Logo */}
      <div className="s-avatar-block" onClick={() => logoInputRef.current?.click()} data-testid="logo-upload">
        <div className="s-avatar s-avatar-logo">
          {logoUrl ? (
            <img src={logoUrl} alt="Logo" className="s-avatar-img" />
          ) : (
            <span className="s-avatar-initials">{getInitials(boutiqueName)}</span>
          )}
          <div className="s-avatar-overlay">
            <Camera size={16} />
            <span>Changer</span>
          </div>
        </div>
        <span className="s-avatar-label">Logo boutique</span>
        <input ref={logoInputRef} type="file" accept="image/*" hidden onChange={(e) => onImageUpload(e.target.files[0], "logo")} />
      </div>

      {/* Center info */}
      <div className="s-profile-center">
        <div className="s-profile-name">{boutiqueName || "Ma Boutique"}</div>
        <span className="s-plan-badge">{plan.toUpperCase()}</span>
        {vitrineUrl && (
          <div className="s-profile-url">
            <span>{vitrineUrl}</span>
            <button onClick={() => { navigator.clipboard.writeText(vitrineUrl); toast.success("Lien copie"); }} className="s-copy-mini"><Copy size={12} /></button>
          </div>
        )}
      </div>

      {/* Profile photo */}
      <div className="s-avatar-block" onClick={() => photoInputRef.current?.click()} data-testid="photo-upload">
        <div className="s-avatar s-avatar-photo">
          {profilePhoto ? (
            <img src={profilePhoto} alt="Photo" className="s-avatar-img" />
          ) : (
            <span className="s-avatar-initials small">{getInitials(user?.name || "")}</span>
          )}
          <div className="s-avatar-overlay">
            <Camera size={14} />
            <span>Modifier</span>
          </div>
        </div>
        <span className="s-avatar-label">Photo de profil</span>
        <input ref={photoInputRef} type="file" accept="image/*" hidden onChange={(e) => onImageUpload(e.target.files[0], "photo")} />
      </div>
    </div>
  );
}
